"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDown = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../atoms/icons");
const typography_1 = require("../../shared/typography");
const Group_1 = require("./Group");
const resources_1 = require("../../resources");
const opposite = (prev) => !prev;
const DropDown = ({ coachName, appCtx, linksGroups, onCtXChange, canChangeCtx }) => {
    const [isOpen, toggleIsOpen] = (0, react_1.useState)(false);
    const [isCtxMenuOpen, toggleCtxMenuOpen] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        window.addEventListener("click", onWindowClick);
        return () => window.removeEventListener("click", onWindowClick);
    }, []);
    const onWindowClick = (e) => {
        var _a, _b;
        if (((_a = e.target.parentNode) === null || _a === void 0 ? void 0 : _a.classList.contains("dropdown")) ||
            ((_b = e.target.parentNode) === null || _b === void 0 ? void 0 : _b.classList.contains("ctx-dropdown"))) {
            return;
        }
        if (e.target.closest(".dropdown") &&
            !(e.target instanceof HTMLAnchorElement)) {
            toggleCtxMenuOpen(false);
            return;
        }
        toggleIsOpen(false);
    };
    const isPBPCtx = appCtx === "PBP";
    const onToggle = (e) => {
        e.stopPropagation();
        toggleIsOpen(opposite);
        toggleCtxMenuOpen(false);
    };
    const onCtxClick = (ctx) => (e) => {
        e.stopPropagation();
        if (ctx === appCtx) {
            return toggleCtxMenuOpen(false);
        }
        onCtXChange(ctx);
        toggleIsOpen(false);
    };
    const onCtxIconClick = (e) => {
        e.stopPropagation();
        toggleIsOpen(opposite);
        toggleCtxMenuOpen(true);
    };
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { onClick: onToggle, children: [(0, jsx_runtime_1.jsx)("div", { onClick: onCtxIconClick, children: isPBPCtx ? (0, jsx_runtime_1.jsx)(resources_1.LogoPBPSquare, {}, void 0) : (0, jsx_runtime_1.jsx)(resources_1.LogoPMPSquare, {}, void 0) }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: coachName }, void 0), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: isOpen ? ["fas", "caret-up"] : ["fas", "caret-down"], color: "grey", size: "lg" }, void 0) }, void 0)] }, void 0), isOpen && ((0, jsx_runtime_1.jsxs)("div", { className: "dropdown", children: [(0, jsx_runtime_1.jsxs)(CtxDropDown, { canChangeCtx: canChangeCtx, className: "ctx-dropdown", children: [isPBPCtx ? (0, jsx_runtime_1.jsx)(resources_1.LogoPBPWithText, {}, void 0) : (0, jsx_runtime_1.jsx)(resources_1.LogoPMPWithText, {}, void 0), isCtxMenuOpen && canChangeCtx && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(LogoWrapper, { isSelected: isPBPCtx, onClick: onCtxClick("PBP"), children: (0, jsx_runtime_1.jsx)(resources_1.LogoPBPWithText, {}, void 0) }, void 0), (0, jsx_runtime_1.jsx)(LogoWrapper, { isSelected: !isPBPCtx, onClick: onCtxClick("PMP"), children: (0, jsx_runtime_1.jsx)(resources_1.LogoPMPWithText, {}, void 0) }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)("div", {}, void 0)] }, void 0))] }, void 0), linksGroups.map((group, idx) => {
                        const key = group.links.length > 0 ? group.title : `${idx}`;
                        return (0, jsx_runtime_1.jsx)(Group_1.Group, { links: group.links, title: group.title }, key);
                    })] }, void 0))] }, void 0));
};
exports.DropDown = DropDown;
const Wrapper = styled_components_1.default.div `
  height: 3rem;
  position: relative;

  p {
    margin-bottom: 0;
  }

  & > div:first-of-type {
    align-items: center;
    cursor: pointer;
    display: flex;
    height: inherit;
    justify-content: center;
    padding: ${({ theme }) => theme.spacings.xs};

    & > div {
      display: flex;
    }

    img {
      height: ${({ theme }) => theme.spacings.l};
    }

    & > p {
      margin-left: ${({ theme }) => theme.spacings.xs};
    }
  }

  & > div:last-of-type:not(:first-of-type) {
    background-color: ${({ theme }) => theme.colors.whiteBase};
    border: 1px solid ${({ theme }) => theme.colors.silverBase};
    padding: ${({ theme }) => `0 0 ${theme.spacings.xs}`};
    position: absolute;
    right: 0;
    width: 207px;
    z-index: 10;

    & > div:not(:first-of-type) {
      padding: ${({ theme }) => `0 ${theme.spacings.xs}`};
    }
  }
`;
const CtxDropDown = styled_components_1.default.div `
  cursor: ${({ canChangeCtx }) => (canChangeCtx ? "pointer" : "unset")};
  position: relative;

  & > div:first-of-type {
    background-color: ${({ theme }) => theme.colors.whiteBase};
    cursor: inherit;
    position: absolute;
    left: 0;
    top: 0;
  }

  & > div:last-of-type {
    background-image: linear-gradient(
      rgba(30, 33, 32, 0.08),
      rgba(30, 33, 32, 0)
    );
    height: 5rem;
    position: absolute;
    pointer-events: none;
    top: 6rem;
    width: 207px;
  }
`;
const LogoWrapper = styled_components_1.default.span `
  background-color: ${({ theme, isSelected }) => isSelected ? theme.colors.whiteBase : theme.colors.silverBase};

  z-index: 20;

  img {
    background-color: inherit;
  }
`;
//# sourceMappingURL=index.js.map